import React, { useMemo, useCallback, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Button, Icon } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import ActionsCourse from '../../../../store/ducks/course';
import SectionCard from '../../../../components/SectionCard';

import useStyles from './styles';

const ErrorMessage = ({ courseEmpty, courseError }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { course: courseId } = useSelector(state => state.course.current);

  const message = useMemo(() => {
    const messageObj = {
      title: '',
      description: '',
    };
    if (courseEmpty) {
      messageObj.title = 'Treinamento indisponível';
      messageObj.description =
        'O treinamento que você está tentando acessar não possuí conteúdo disponível para visualização no momento.';
    }
    if (courseError) {
      messageObj.title = 'Conteúdo indisponível';
      messageObj.description =
        'Ocorreu um erro ao carregar o conteúdo do treinamento.';
    }
    if (!courseEmpty && !courseError) {
      messageObj.title = 'Aula não disponível';
      messageObj.description =
        'A aula que você está tentando acessar não existe ou ainda não está disponível para visualização.';
    }
    return messageObj;
  }, [courseEmpty, courseError]);

  const handleClickRetry = useCallback(() => {
    dispatch(ActionsCourse.requestCourse(courseId));
  }, [courseId, dispatch]);

  return (
    <SectionCard className={classes.container}>
      <Helmet>
        <title>Aula não disponível.</title>
      </Helmet>
      <Box className="error-message-content">
        <Icon className="error-message-icon">warning</Icon>
        <Typography className="error-message-title" variant="h4">
          {message.title}
        </Typography>
        <Typography className="error-message-description" variant="body1">
          {message.description}
        </Typography>
        <Button
          className="error-message-button"
          variant="contained"
          color="primary"
          startIcon={<Icon>keyboard_backspace</Icon>}
          component={Link}
          to="/"
        >
          Voltar para o início
        </Button>
        <Button className="error-message-button" onClick={handleClickRetry}>
          Tentar novamente
        </Button>
      </Box>
    </SectionCard>
  );
};

export default memo(ErrorMessage);
